// import AcceptQuoteLayout from '../../layouts/AcceptQuoteLayout';
// import { getQuoteById } from '../../store/slices/customerSlice';
// import { useDispatch, useSelector } from 'react-redux';
// import OrderGenerate from "../Customer/OrderGenerate";
// import { useParams } from 'react-router-dom';
// import React, { useEffect, useState } from 'react';

// const AcceptQuote = () => {
//   const { id } = useParams();
//   const dispatch = useDispatch();
//   const [request, setRequest] = useState([])
//   const { orderDetails } = useSelector((state) => state.customer);
//   const { orderData } = useSelector((state) => state.supplier);

//   const handleOrder = () => {
//     dispatch(getQuoteById(id));
//   }

//   useEffect(()=>{
//     dispatch(getQuoteById(id));
//   },[dispatch, id]);

//   useEffect(()=>{},[orderDetails, orderData])

//   return (
//     <div>
//       <AcceptQuoteLayout id={id} handleOrder={handleOrder} />
//       {orderDetails && orderData ? <OrderGenerate orderData={orderData} />:""}
//     </div>
//   )
// }

// export default AcceptQuote;

import React, { useEffect, useCallback } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import AcceptQuoteLayout from "../../layouts/AcceptQuoteLayout";
import OrderGenerate from "../Customer/OrderGenerate";

import { getQuoteById } from "../../store/slices/customerSlice";
import { refreshIfNeeded } from "../../store/actions/refreshIfNeeded";

const AcceptQuote = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { orderDetails } = useSelector((state) => state.customer);
  const { orderData } = useSelector((state) => state.supplier);

  // ensure fresh token before any API dispatch
  const ensureAuth = useCallback(async () => {
    await dispatch(refreshIfNeeded());
  }, [dispatch]);

  // initial load (with fresh token)
  useEffect(() => {
    if (!id) return;
    (async () => {
      await ensureAuth();
      dispatch(getQuoteById(id));
    })();
  }, [id, dispatch, ensureAuth]);

  // click handler (with fresh token)
  const handleOrder = useCallback(async () => {
    if (!id) return;
    await ensureAuth();
    dispatch(getQuoteById(id));
  }, [id, ensureAuth, dispatch]);

  return (
    <div>
      <AcceptQuoteLayout id={id} handleOrder={handleOrder} />
      {orderDetails && orderData ? (
        <OrderGenerate orderData={orderData} showButton />
      ) : null}
    </div>
  );
};

export default AcceptQuote;
